import axios from "axios";
import { config } from "../../utils/axiosconfig";
import { base_url } from "../../utils/baseUrl";

const getCurriculamAll = async () => {
  const response = await axios.get(
    `${base_url}curriculam/allcurriculam`,
    config
  );

  return response.data;
};

const getCurriculams = async () => {
  const response = await axios.post(
    `${base_url}user/allcurriculamdata`,
    config
  );

  return response.data;
};

const deleteCurriculam = async (id) => {
  const response = await axios.delete(`${base_url}enquiry/${id}`, config);
  return response.data;
};
const getCurriculam = async (id) => {
  const response = await axios.get(`${base_url}enquiry/${id}`);
  return response.data;
};
const udpateCurriculam = async (enq) => {
  const response = await axios.put(
    `${base_url}enquiry/${enq.id}`,
    { status: enq.enqData },
    config
  );
  return response.data;
};

//new endpoint added
const getCurriculamData = async () => {
  const response = await axios.get(`${base_url}curriculam/`, config);

  return response.data;
};

const getCurriculamCompletionCount = async (queryParams) => {
  const response = await axios.get(
    `${base_url}curriculam/complitionCount?${queryParams}`,
    config
  );
  return response.data;
};

const getGraphDataList = async () => {
  const response = await axios.get(
    `${base_url}curriculam/get-graph-data`,
    config
  );
  return response.data;
};

const enquiryService = {
  getCurriculamAll,
  getCurriculams,
  getCurriculamData,
  getCurriculamCompletionCount,
  deleteCurriculam,
  getCurriculam,
  udpateCurriculam,
  getGraphDataList,
};

export default enquiryService;
